export const truncateWords = (str, count, suffix) => {
  if (str && count) {
    const num = Number(count);
    let arr = str.split(/[ \t]/);
    let val;
    if (num < arr.length) {
      arr = arr.slice(0, num);
      val = `${arr.join(' ').trim()}${suffix || '…'}`;
    } else {
      val = str;
    }

    return val;
  }
};
